<template>
  <div class="page_box">
    <div class="page_option_box">
      <!-- 监控列表 -->
      <el-page-header
        @back="goBack"
        content="监控权限信息"
      >
      </el-page-header>
    </div>
    <div class="page_table_box">
      <div class="info-content-box">
        <el-form ref="form" :model="form" label-width="120px" class="form-box">
          <el-form-item label="是否公开摄像:">
            <el-radio-group v-model="form.status">
              <el-radio
                v-for="(item, index) in statusList"
                :key="index"
                :label="item.value"
                >{{ item.name }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="选择人员:" v-if="form.status == 1">
            <div class="user-name-box" @click="userClick">
              {{ form.userNames }}
            </div>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
        <div class="bottom-btn-box">
          <el-button type="primary" size="small" @click="saveClick"
            >保存</el-button
          >
          <el-button size="small" @click="goBack">取消</el-button>
        </div>
      </div>
    </div>
    <el-dialog
      title="添加成员"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="650px"
      :before-close="handleClose"
      :visible.sync="showDialog"
      direction="ltr"
    >
      <div
        style="display: flex;
      justify-content: center;
      align-items: center;"
      >
        <el-transfer
          v-model="powerInfo.userIds"
          :props="{
            key: 'userId',
            label: 'userName'
          }"
          ref="transferRef"
          :titles="['待选择成员列表', '待提交成员列表']"
          :data="departmentHead"
          filterable
          :filter-method="filterMethod"
          filter-placeholder="请输入成员名称"
        >
          <el-button
            class="transfer-footer"
            type="primary"
            style="float:right;margin:5px"
            slot="right-footer"
            size="small"
            :disabled="powerInfo.userIds.length > 0 ? false : true"
            @click="addJobPersonnel()"
            >提交</el-button
          >
        </el-transfer>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {},
  data() {
    //这里存放数据
    return {
      form: {
        monitorId: "",
        users: [],
        status: 0,
        userNames: ""
      },
      statusList: [
        { name: "全部公开", value: 0 },
        { name: "部分公开", value: 1 }
      ],
      departmentHead: [],
      showDialog: false,
      filterMethod(query, item) {
        return item.userName.indexOf(query) > -1;
      },
      powerInfo: {
        userIds: [],
        monitorIds: []
      }
    };
  },
  //监控data中的数据变化
  watch: {},
  //计算属性，类似于data概念
  computed: {},
  //方法集合
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async getInfo() {
      let req = { monitorId: this.$route.query.monitorId };
      let res = await this.$Http.getMonitorsInfo(req);
      if (res.code == 200) {
        this.form = res.data || [];
        let data = res.data.users || [];
        let userNames = data.map((item, index) => {
          return item.userName || "";
        });
        this.form.userNames = userNames.join(",");
        this.powerInfo.userIds = data.map((item, index) => {
          return item.userId || "";
        });
      } else if (res.code == 101) {
        this.form = {
          monitorId: "",
          users: [],
          status: 0,
          userNames: ""
        };
      } else {
        this.form = {
          monitorId: "",
          users: [],
          status: 0,
          userNames: ""
        };
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取部门及部门人员
    async getDepartmentHead() {
      var paramData = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getDepartmentHead(paramData, true);
      if (res.code == 200) {
        let data = res.data || [];
        let newData = [];
        data.forEach((item, index) => {
          if (item.dlist.length > 0) {
            newData.push.apply(newData, item.dlist);
          }
        });
        this.departmentHead = newData;
        this.showDialog = true;
      } else if (res.code == 101) {
        this.departmentHead = [];
      } else {
        this.departmentHead = [];
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    handleClose() {
      this.showDialog = false;
    },
    userClick() {
      this.getDepartmentHead();
    },
    addJobPersonnel() {
      this.showDialog = false;
      let names = this.$refs.transferRef.targetData.map((item, index) => {
        return item.userName || "";
      });
      this.form.userNames = names.join(",");
    },
    // 保存
    saveClick() {
      if (this.form.status == 0) {
        this.powerInfo.userIds = [];
      }
      this.powerAdd();
    },
    //
    async powerAdd() {
      let res = await this.$Http.powerAdd(this.powerInfo);
      if (res.code == 200) {
        this.goBack();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {
    let monitorIds = this.$route.query.monitorId.split(",");
    if (monitorIds.length == 1) {
      this.getInfo();
    }
    this.powerInfo.monitorIds = monitorIds;
  },
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.info-content-box {
  height: 100%;
  padding: 20px;
}
.user-name-box {
  width: 100%;
  min-height: 50px;
  max-height: 450px;
  overflow-y: scroll;
  background-color: rgb(238, 238, 238);
  cursor: pointer;
  word-break: break-all;
  white-space: normal;
}
.form-box{
  width: 100%;
  height: calc(100% - 149px);
  overflow-y: scroll;
}
.bottom-btn-box {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 100px;
}
</style>
